<template>
    <div class="page-header signup-page section-image">
        <div class="page-header-image"
             style="background-image: url('img/throw300/bg-gopinsetters.jpg')">
        </div>
        <div id="signup" class="content">
            <div class="container">
                <div class="row">
                    <div class="col-md-4 ml-auto mr-auto">
                        <div class="info info-horizontal">
                            <div class="icon icon-primary">
                                <i class="now-ui-icons media-2_sound-wave"></i>
                            </div>
                            <div class="description">
                                <h5 class="info-title">Bowling</h5>
                                <p class="description">
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis viverra mauris a purus venenatis, 
                                    sit amet vestibulum neque porta.
                                </p>
                            </div>
                        </div>
                        <div class="info info-horizontal">
                            <div class="icon icon-primary">
                                <i class="now-ui-icons media-1_button-pause"></i>
                            </div>
                            <div class="description">
                                <h5 class="info-title">Networking</h5>
                                <p class="description">
                                    Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. 
                                    Integer non erat pulvinar, accumsan ipsum at, iaculis arcu.
                                </p>
                            </div>
                        </div>
                        <div class="info info-horizontal">
                            <div class="icon icon-info">
                                <i class="now-ui-icons users_single-02"></i>
                            </div>
                            <div class="description">
                                <h5 class="info-title">Friends</h5>
                                <p class="description">
                                    Ut venenatis ornare condimentum. Praesent viverra dolor ac sem ultricies sollicitudin. 
                                </p>
                            </div>
                        </div>
                    </div>
                    
                    <!--  https://scotch.io/courses/getting-started-with-vuejs/processing-a-form-with-vue -->
                    <div class="col-md-4 mr-auto">
                        <div class="card card-signup">
                            <div class="card-body">
                            <form id="register-form" @submit.prevent="processForm">
                                <h4 class="card-title text-center">Register</h4>
                                <div id="errorMessage" v-show="errors.length > 0">
                                    <Alert type="danger" ref="error"><div v-for="obj in errors" v-model="obj.str">{{obj.toString()}}</div></Alert>
                                </div>
                                <!--
                                <div class="social text-center">
                                    <n-button round icon class="btn-twitter">
                                        <i class="fab fa-twitter"></i>
                                    </n-button>
                                    <n-button round icon class="btn-dribbble">
                                        <i class="fab fa-dribbble"></i>
                                    </n-button>
                                    <n-button round icon class="btn-facebook">
                                        <i class="fab fa-facebook"> </i>
                                    </n-button>
                                    <h5 class="card-description"> or be classical </h5>
                                </div>
                                -->
                                <fg-input addon-left-icon="now-ui-icons users_circle-08"
                                        required
                                        v-model="form.firstName"
                                        placeholder="First Name...">
                                    
                                </fg-input>
                                <div v-model="form.firstNameError">{{form.firstNameError}}</div>        
                                <fg-input addon-left-icon="now-ui-icons text_caps-small"
                                        required
                                        value=""
                                        v-model="form.lastName"
                                        placeholder="Last Name...">
                                </fg-input>


                                <fg-input addon-left-icon="now-ui-icons ui-1_email-85"
                                        type="email"
                                        required
                                        v-model="form.email"
                                        placeholder="Your Email...">
                                </fg-input>

                                <n-checkbox v-model="form.agree" required>
                                    I agree to the terms and
                                    <a href="#something">conditions</a>.
                                </n-checkbox>
                                <div class="card-footer text-center">
                                    <n-button type="primary"  round size="lg" @click.native="Signup">Get Started</n-button>
                                </div>
                             </form>
                            </div>
                        </div>
                    </div>
                   
                </div>
            </div>
        </div>
        <main-footer></main-footer>
    </div>
</template>
<script>
  import axios from "axios";
  import { Card, Button, FormGroupInput, Checkbox, Alert } from '@/components';
  
  import MainFooter from '@/throw300-layout/MainFooter';

  export default {
    name: 'signup-page',
    bodyClass: 'signup-page',
    components: {
      Card,
      MainFooter,
      [Button.name]: Button,
      [Checkbox.name]: Checkbox,
      [FormGroupInput.name]: FormGroupInput,
      Alert
    },
    data() {
      return {
        form: {
          firstName: '',
          lastName: '',
          email: '',
          agree: false,
          //errors: ["error 1", "error 2", "error 3 - edited"],
          firstNameError: ""
        },
        errors: []
      }
    },
    methods: {
        processForm: function () {
            console.log('registering...');
        },
        Signup() {
            console.log("signup post...");
            console.log(this)
            var data = {
                first: this.form.firstName,
                last: this.form.lastName,
                email: this.form.email,
                agree: this.form.agree
            }
            this.errors = [];
            //console.log(data);
            //console.log(this.$refs["error"]);
            //this.$refs["error"].innerHTML = data.firstName;
            
            //axios({"method": "POST", "url": "https://localhost:22553/account/start"}).then(result => {
            axios.post("https://localhost:22553/account/start", data).then(result => {
                console.log(result);
                if(result.data.errorMessages.length > 0)
                    this.errors = result.data.errorMessages;
                else {
                    this.errors = ["ready for processing."];
                }
            }, error => {
                console.error(error);
            });
            /*
            http.getJSON("http://localhost:7071/api/Function1?name=doug").then(result => {
                console.log(result.results);
            }, error => {
                console.log(error);
            });*/
        }
    },
    watch: {
        firstName(value) {
             
        }
    }
  }

  
</script>
<style>
</style>
